import React, { ReactNode } from 'react';
import styles from './tab.module.scss';

type Props = {
  children: ReactNode;
  onClick: () => void;
  active?: boolean;
  cardHeaderTab?: boolean;
  className?: string;
}

const Tab = ({ children, onClick, active, className, cardHeaderTab }: Props) => {
  // helpers
  const getClasses = () => { 
    let tabClass = cardHeaderTab ? styles.tabHeader : styles.tab;
    let activeClass = active ? " active" : "";
    let customClass = className ? ` ${className}` : "";
    return `${tabClass}${activeClass}${customClass}`;
  }

  // render
  return (
    <a className={getClasses()} onClick={onClick}>
      {children}
    </a>
  )
}

export default Tab;